import Icon from "@mui/icons-material/AccountBalance";

import YearlyLedgerCreate from "./YearlyLedgerCreate";

export default {
  create: YearlyLedgerCreate,
  icon: Icon,
  name: "yearly-ledger",
};
